defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/NoClubs', [
  'Shared/Framework/Mithril/Scripts/Core/Mithril',
  'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
  'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/PostCard'
],
function (m, CtaButton, PostCard) {
  // Context:
  var NoClubs = function (controller) {
    const noClubsBackground = controller.settings.backgroundImage;
    // Return:
    return [
      m('.play-together-no-clubs', [
        noClubsBackground?.length ? m('img.play-together-no-clubs__background', {
          src: noClubsBackground
        }) : null,
        m('.play-together-no-clubs__content', [
          m('.play-together-no-clubs__title', controller.dictionary('NoClubs/Title')),
          m('.play-together-no-clubs__description', m.trust(controller.dictionary('NoClubs/Description')))
        ])
      ]),
      PostCard({
        type: 'promote',
        title: controller.dictionary('Onboarding/Title'),
        description: controller.dictionary('Onboarding/Description'),
        $footer: CtaButton({
          text: controller.dictionary('Onboarding/GoToGuideButton'),
          href: controller.navigationPaths.guidePage,
          options: ['small', 'transparent', 'white']
        })
      })
    ];
  };

  // Public functions:
  return NoClubs;
});
